import { useCallback } from 'react';
import type { TSizeSpan } from '@timeedit/types';
import { Icon, TEInput } from '@timeedit/ui-components';
import { Button, Space } from '@timeedit/ui-components/antd';

type TSizeSpansProps = {
  value: TSizeSpan[];
  onChange: (value: TSizeSpan[]) => void;
};

const SizeSpans = ({ value, onChange }: TSizeSpansProps) => {
  const onAdd = useCallback(() => {
    const newValue: TSizeSpan[] = [...value, [0, 0]];
    onChange(newValue);
  }, [value, onChange]);

  const onDelete = useCallback(
    (index: number) => {
      onChange(value.filter((_, i) => i !== index));
    },
    [value, onChange]
  );

  const handleChange = useCallback(
    (index: number, newValue: TSizeSpan) => {
      onChange(value.map((sizeSpan, i) => (i === index ? newValue : sizeSpan)));
    },
    [value, onChange]
  );

  return (
    <TEInput.LabelWrapper
      label="Size Spans"
      tooltip="Will fetch objects that sastify the requested size in size spans"
    >
      <Space direction="vertical">
        {value.map((sizeSpan, index) => (
          <SizeSpanInput
            key={index}
            value={sizeSpan}
            onChange={(value) => handleChange(index, value)}
            onDelete={() => onDelete(index)}
          />
        ))}
        <Button
          icon={<Icon id="PlusOutlined" alt="Plus" />}
          size="small"
          onClick={onAdd}
        >
          Add size span
        </Button>
      </Space>
    </TEInput.LabelWrapper>
  );
};

export default SizeSpans;

type TSizeSpanInputProps = {
  value: TSizeSpan;
  onChange: (value: TSizeSpan) => void;
  onDelete: () => void;
};
const SizeSpanInput = ({ value, onDelete, onChange }: TSizeSpanInputProps) => {
  return (
    <Space>
      <TEInput.InputNumberMinMax
        value={value}
        onChange={onChange}
        debounceTime={100}
      />
      <Button
        size="small"
        icon={<Icon id="DeleteOutlined" alt="Delete" />}
        onClick={onDelete}
        danger
      ></Button>
    </Space>
  );
};
